import { defineMessages } from 'react-intl';

export default defineMessages({
  continueCta: {
    id: 'src.pages.VendorLocator.continueCta',
    defaultMessage: 'Continue',
  },
  saveContinueCta: {
    id: 'src.pages.VendorLocator.saveContinueCta',
    defaultMessage: 'Save & continue later',
  },
  requiredErrorMessage: {
    id: 'src.pages.VendorLocator.requiredErrorMessage',
    defaultMessage: 'Oops! Looks like you forgot to fill this in.',
  },
  noLocationsError1: {
    id: 'src.pages.VendorLocator.noLocationsError1',
    defaultMessage: 'Uh oh! Something went wrong. Please try again or give us a call at ',
  },
  noLocationsError2: {
    id: 'src.pages.VendorLocator.noLocationsError2',
    defaultMessage: '1-844-766-6384',
  },
  noLocationsError3: {
    id: 'src.pages.VendorLocator.noLocationsError3',
    defaultMessage: '. You can also continue with your claim and a Claims team member will arrange this for you later.',
  },
  landingHeading: {
    id: 'src.pages.VendorLocator.landingHeading',
    defaultMessage: 'Let\'s take care of your vehicle',
  },
  introCopy: {
    id: 'src.pages.VendorLocator.introCopy',
    defaultMessage: 'It\'s highly recommended to use one of our certified repair shops in your area. This is a one-stop shop, end-to-end experience with high customer satisfaction.',
  },
  listIntro: {
    id: 'src.pages.VendorLocator.listIntro',
    defaultMessage: 'Our certified shops will:',
  },
  list1: {
    id: 'src.pages.VendorLocator.list1',
    defaultMessage: 'Take care of you and your vehicle',
  },
  list2: {
    id: 'src.pages.VendorLocator.list2',
    defaultMessage: 'Have experience in repairing your type of vehicle and deliver high quality repairs',
  },
  list3: {
    id: 'src.pages.VendorLocator.list3',
    defaultMessage: 'Guarantee the work completed for as long as you own the vehicle',
  },
  list4: {
    id: 'src.pages.VendorLocator.list4',
    defaultMessage: 'Approve estimates quickly',
  },
  list5: {
    id: 'src.pages.VendorLocator.list5',
    defaultMessage: 'Arrange for a rental (if rental coverage is available)',
  },
  selectRepairCta: {
    id: 'src.pages.VendorLocator.selectRepairCta',
    defaultMessage: 'Select repair shop',
  },
  speakToSomeoneCta: {
    id: 'src.pages.VendorLocator.speakToSomeoneCta',
    defaultMessage: 'I\'d like to speak to someone',
  },
  selectRepairShop: {
    id: 'src.pages.VendorLocator.selectRepairShop',
    defaultMessage: 'Select a certified repair shop',
  },
  lastStep: {
    id: 'src.pages.VendorLocator.lastStep',
    defaultMessage: 'One last step',
  },
  howItWorks1: {
    id: 'src.pages.VendorLocator.howItWorks1',
    defaultMessage: 'Type in your address to find a certified repair shop near you',
  },
  howItWorks2: {
    id: 'src.pages.VendorLocator.howItWorks2',
    defaultMessage: 'Pick an appointment day and time (if available)',
  },
  howItWorks3: {
    id: 'src.pages.VendorLocator.howItWorks3',
    defaultMessage: 'Bring in your vehicle to the selected repair shop',
  },
  howItWorks: {
    id: 'src.pages.VendorLocator.howItWorks',
    defaultMessage: 'How it works:',
  },
  shopWill: {
    id: 'src.pages.VendorLocator.shopWill',
    defaultMessage: 'The certified repair shop will:',
  },
  shopWill1: {
    id: 'src.pages.VendorLocator.shopWill1',
    defaultMessage: 'Handle the appraisal',
  },
  shopWill2: {
    id: 'src.pages.VendorLocator.shopWill2',
    defaultMessage: 'Inspect and document your vehicle\'s damage',
  },
  shopWill3: {
    id: 'src.pages.VendorLocator.shopWill3',
    defaultMessage: 'Provide you with an estimate of the work required',
  },
  shopWill4: {
    id: 'src.pages.VendorLocator.shopWill4',
    defaultMessage: 'Issue you a rental vehicle (if rental coverage is available)',
  },
  shopWill5: {
    id: 'src.pages.VendorLocator.shopWill5',
    defaultMessage: 'With your permission, they\'ll start the repairs to your vehicle',
  },
  locationNearMe: {
    id: 'src.pages.VendorLocator.locationNearMe',
    defaultMessage: 'Find locations near me',
  },
  addressPlaceholder: {
    id: 'src.pages.VendorLocator.addressPlaceholder',
    defaultMessage: 'Address',
  },
  chooseShop: {
    id: 'src.pages.VendorLocator.chooseShop',
    defaultMessage: 'Choose from our certified repair shops in your area:',
  },
  chooseAppointment: {
    id: 'src.pages.VendorLocator.chooseAppointment',
    defaultMessage: 'Let\'s choose an appointment',
  },
  youveSelectedShop: {
    id: 'src.pages.VendorLocator.youveSelectedShop',
    defaultMessage: 'You\'ve selected our certified shop',
  },
  selectDay: {
    id: 'src.pages.VendorLocator.selectDay',
    defaultMessage: 'Select an available day',
  },
  selectTime: {
    id: 'src.pages.VendorLocator.selectTime',
    defaultMessage: 'Select an available time',
  },
  dropdownPlaceholder: {
    id: 'src.pages.VendorLocator.dropdownPlaceholder',
    defaultMessage: 'Select',
  },
  timesPlaceholder: {
    id: 'src.pages.VendorLocator.timesPlaceholder',
    defaultMessage: 'times available',
  },
  pickShopCta: {
    id: 'src.pages.VendorLocator.pickShopCta',
    defaultMessage: 'Pick a different shop',
  },
  appointmentDetails: {
    id: 'src.pages.VendorLocator.appointmentDetails',
    defaultMessage: 'Your repair shop appointment details',
  },
  initialBook: {
    id: 'src.pages.VendorLocator.initialBook',
    defaultMessage: 'We will book an initial inspection appointment with:',
  },
  viewMap: {
    id: 'src.pages.VendorLocator.viewMap',
    defaultMessage: 'View map',
  },
  addToCalendar: {
    id: 'src.pages.VendorLocator.addToCalendar',
    defaultMessage: 'Add to calendar',
  },
  noDatesAvailableTitle: {
    id: 'src.pages.VendorLocator.noDatesAvailableTitle',
    defaultMessage: 'No dates available',
  },
  noDatesAvailableText: {
    id: 'src.pages.VendorLocator.noDatesAvailableText',
    defaultMessage: 'There aren\'t any current appointments available for this shop within the next two weeks. You can still contact them to schedule an inspection at their earliest convenience.',
  },
  initialNoBook: {
    id: 'src.pages.VendorLocator.initialNoBook',
    defaultMessage: 'You\'ve selected our certified shop - we\'ll let them know you\'ve selected them for repairs.',
  },
  reachOutTo: {
    id: 'src.pages.VendorLocator.reachOutTo',
    defaultMessage: 'To schedule an initial inspection, reach out to:',
  },
  connectWithUs: {
    id: 'src.pages.VendorLocator.connectWithUs',
    defaultMessage: 'Connect with us',
  },
  chat: {
    id: 'src.pages.VendorLocator.chat',
    defaultMessage: 'Chat',
  },
  chatDescription1: {
    id: 'src.pages.VendorLocator.chatDescription1',
    defaultMessage: 'Just type  “',
  },
  chatDescriptionBold: {
    id: 'src.pages.VendorLocator.chatDescriptionBold',
    defaultMessage: 'Claims help',
  },
  chatDescription2: {
    id: 'src.pages.VendorLocator.chatDescription2',
    defaultMessage: '” into the chat to escalate your issue and we’ll connect you with a live Claims team member.',
  },
  call: {
    id: 'src.pages.VendorLocator.call',
    defaultMessage: 'Call',
  },
  call1: {
    id: 'src.pages.VendorLocator.call1',
    defaultMessage: 'Give us a call at',
  },
  call2: {
    id: 'src.pages.VendorLocator.call2',
    defaultMessage: ' 1-844-766-6384 ',
  },
  call3: {
    id: 'src.pages.VendorLocator.call3',
    defaultMessage: 'and follow the prompts to talk to a Claims team member.',
  },
  draftSavedMsg: {
    id: 'src.pages.VendorLocator.draftSavedMsg',
    defaultMessage: 'A draft of your claim has been saved to your dashboard. To finalize and submit your claim, connect with a Claims team member to talk about your repair options.',
  },
  startChatBtn: {
    id: 'src.pages.VendorLocator.startChatBtn',
    defaultMessage: 'Start chat',
  },
  sorryNotAvailable: {
    id: 'src.pages.VendorLocator.sorryNotAvailable',
    defaultMessage: 'Sorry, your appointment is no longer available',
  },
  chooseNewAppointment: {
    id: 'src.pages.VendorLocator.chooseNewAppointment',
    defaultMessage: 'Please choose a new appointment date and/or time to continue. You can also go back and change your certified repair shop to see other available appointments.',
  },
  okay: {
    id: 'src.pages.VendorLocator.okay',
    defaultMessage: 'Okay',
  },
});
